import { render, staticRenderFns } from "./Funnel.vue?vue&type=template&id=675c0cfd&scoped=true&"
import script from "./Funnel.vue?vue&type=script&lang=js&"
export * from "./Funnel.vue?vue&type=script&lang=js&"
import style0 from "./Funnel.vue?vue&type=style&index=0&id=675c0cfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c0cfd",
  null
  
)

export default component.exports